<nb-card>
    <nb-card-header>{{ 'contacts' | translate }}</nb-card-header>
    <nb-card-body>
        <div class="crm-contacts" *ngIf="contacts.length">
            <div class="contact-row" *ngFor="let c of contacts">
                <div class="contact-info">
                    <span class="primary-star" *ngIf="c.is_primary" title="{{ 'primarycontact' | translate }}">★</span>
                    <ng-container *ngIf="editingContactId !== c.id">
                        <strong>{{ c.name }}</strong>
                        <span *ngIf="c.role"> — {{ c.role }}</span>
                        <div class="contact-meta">{{ c.email }} {{ c.phone }}</div>
                    </ng-container>
                    <ng-container *ngIf="editingContactId === c.id">
                        <input nbInput fieldSize="small" [(ngModel)]="c.name" placeholder="{{ 'contactname' | translate }}">
                        <input nbInput fieldSize="small" [(ngModel)]="c.role" placeholder="{{ 'contactrole' | translate }}">
                        <input nbInput fieldSize="small" [(ngModel)]="c.email" placeholder="{{ 'contactemail' | translate }}">
                        <input nbInput fieldSize="small" [(ngModel)]="c.phone" placeholder="{{ 'contactphone' | translate }}">
                    </ng-container>
                </div>
                <div class="contact-actions">
                    <button nbButton ghost size="tiny" *ngIf="editingContactId !== c.id && !c.is_primary" (click)="makePrimary(c)">{{ 'makeprimary' | translate }}</button>
                    <button nbButton ghost size="tiny" *ngIf="editingContactId !== c.id" (click)="startEditContact(c)">{{ 'edit' | translate }}</button>
                    <button nbButton ghost size="tiny" status="success" *ngIf="editingContactId === c.id" (click)="saveContact(c)">{{ 'save' | translate }}</button>
                    <button nbButton ghost size="tiny" status="danger" (click)="removeContact(c)">{{ 'delete' | translate }}</button>
                </div>
            </div>
        </div>

        <div class="crm-add-contact">
            <input nbInput fieldSize="small" [(ngModel)]="newContact.name" placeholder="{{ 'contactname' | translate }}">
            <input nbInput fieldSize="small" [(ngModel)]="newContact.role" placeholder="{{ 'contactrole' | translate }}">
            <input nbInput fieldSize="small" [(ngModel)]="newContact.email" placeholder="{{ 'contactemail' | translate }}">
            <input nbInput fieldSize="small" [(ngModel)]="newContact.phone" placeholder="{{ 'contactphone' | translate }}">
            <button nbButton size="small" status="primary" [disabled]="!newContact.name" (click)="addContact()">{{ 'addcontact' | translate }}</button>
        </div>
    </nb-card-body>
</nb-card>

<nb-card>
    <nb-card-header>{{ 'activitytimeline' | translate }}</nb-card-header>
    <nb-card-body>
        <div class="crm-log-activity">
            <nb-select size="small" [(selected)]="newActivity.type">
                <nb-option *ngFor="let t of activityTypes" [value]="t">{{ ('activity_type_' + t) | translate }}</nb-option>
            </nb-select>
            <nb-select size="small" [(selected)]="newActivity.Contact_id" *ngIf="contacts.length">
                <nb-option [value]="null">{{ 'nocontact' | translate }}</nb-option>
                <nb-option *ngFor="let c of contacts" [value]="c.id">{{ c.name }}</nb-option>
            </nb-select>
            <input nbInput fullWidth fieldSize="small" [(ngModel)]="newActivity.body" placeholder="{{ 'logactivityplaceholder' | translate }}">
            <button nbButton size="small" status="primary" [disabled]="!newActivity.body" (click)="logActivity()">{{ 'logactivity' | translate }}</button>
        </div>

        <ul class="crm-timeline" *ngIf="activities.length">
            <li *ngFor="let a of activities" [class]="'activity-' + a.type">
                <span class="activity-type">{{ ('activity_type_' + a.type) | translate }}</span>
                <span class="activity-when">{{ a.occurred_at | date:'short' }}</span>
                <span class="activity-who" *ngIf="activityLabel(a) as who">· {{ who }}</span>
                <div class="activity-body">{{ a.body }}<span *ngIf="a.contact"> ({{ a.contact.name }})</span></div>
            </li>
        </ul>
        <div *ngIf="!activities.length" class="crm-empty">{{ 'noactivityyet' | translate }}</div>
    </nb-card-body>
</nb-card>

<nb-card>
    <nb-card-header>{{ 'opportunityhistory' | translate }}</nb-card-header>
    <nb-card-body>
        <table class="crm-opportunities" *ngIf="opportunities.length">
            <tr *ngFor="let o of opportunities">
                <td>
                    <a [routerLink]="['/opportunities', o.id]">{{ o.title }}</a>
                    <div class="opp-meta">
                        <span class="status-badge" [class]="'is-' + o.status">{{ ('crm.opp.' + o.status) | translate }}</span>
                        <span *ngIf="o.rate_target != null">· €{{ o.rate_target }}/h</span>
                        <span *ngIf="opportunityOwnerName(o) as ownerName">· {{ ownerName }}</span>
                        <span *ngIf="o.won_at">· {{ 'wonon' | translate }} {{ o.won_at | date:'d MMM y' }}</span>
                        <span *ngIf="!o.won_at && o.submission_deadline">· {{ 'crm.col.deadline' | translate }}: {{ o.submission_deadline | date:'d MMM y' }}</span>
                    </div>
                </td>
            </tr>
        </table>
        <div *ngIf="!opportunities.length" class="crm-empty">{{ 'noopportunityyet' | translate }}</div>
    </nb-card-body>
</nb-card>
